import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

interface PageHeaderProps {
  variant?: 'back' | 'dashboard' | 'simple';
  title: string;
  subtitle?: string;
  backTo?: string;
  onLogout?: () => void;
  rightAction?: React.ReactNode;
}

const BackArrowIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_152_868)">
      <path d="M6.52337 9.16664H16.6667V10.8333H6.52337L10.9934 15.3033L9.81504 16.4816L3.33337 9.99998L9.81504 3.51831L10.9934 4.69664L6.52337 9.16664Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_152_868">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export function PageHeader({
  variant = 'simple',
  title,
  subtitle,
  backTo,
  onLogout,
  rightAction,
}: PageHeaderProps) {
  const navigate = useNavigate();

  if (variant === 'back') {
    return (
      <header className="sticky top-0 z-10 bg-background border-b border-border">
        <div className="relative flex items-center justify-center h-14 px-4 py-3">
          <button
            onClick={() => backTo && navigate(backTo)}
            className="absolute left-4 h-10 w-10 flex items-center justify-center text-foreground hover:opacity-60 transition-opacity"
          >
            <BackArrowIcon />
          </button>
          <h1 className="text-lg font-semibold">{title}</h1>
          {rightAction && <div className="absolute right-4">{rightAction}</div>}
        </div>
      </header>
    );
  }

  if (variant === 'dashboard') {
    return (
      <header className="sticky top-0 z-10 bg-white px-4 py-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-400 mb-1">Welcome!</p>
            <h1 className="text-xl font-bold text-black">{title}</h1>
          </div>
          {rightAction && rightAction}
        </div>
      </header>
    );
  }

  return (
    <header className="sticky top-0 z-10 bg-background border-b border-border">
      <div className="flex items-center justify-between h-14 px-4 py-3">
        <h1 className="text-lg font-semibold">{title}</h1>
        {rightAction && rightAction}
      </div>
    </header>
  );
}
